import { APP_ROUTES } from './routes.type';

const ERROR_CODE_TITLES: Record<number, string> = {
  401: 'Ошибка 401',
  403: 'Ошибка 403',
  404: 'Ошибка 404',
  500: 'Ошибка 500',
  503: 'Ошибка 503',
};

const PATH_TITLES: Record<string, string> = {
  ['/' + APP_ROUTES.PROFILE]: 'Профиль',
  ['/' + APP_ROUTES.SOCIAL_PROFILE]: 'Социальный профиль',
  ['/' + APP_ROUTES.QUESTIONNAIRE]: 'Основной опросник',
  ['/' + APP_ROUTES.DAILY_REFLECTION]: 'Ежедневная рефлексия',
  ['/' + APP_ROUTES.DAILY_REFLECTION_PERSPECTIVE_PATH]: 'Ежедневная рефлексия — перспектива',
  ['/' + APP_ROUTES.DAILY_REFLECTION_RETROSPECTIVE_PATH]: 'Ежедневная рефлексия — ретроспектива',
  ['/' + APP_ROUTES.HISTORY]: 'История',
  ['/' + APP_ROUTES.REFERENCE]: 'Справочник',
  ['/' + APP_ROUTES.BLOG]: 'Блог',
  ['/' + APP_ROUTES.LOGIN]: 'Вход',
  ['/' + APP_ROUTES.REGISTER]: 'Регистрация',
  ['/' + APP_ROUTES.RESET]: 'Сброс пароля',
  ['/' + APP_ROUTES.FORGOT]: 'Восстановление пароля',
  ['/' + APP_ROUTES.VERIFY_EMAIL]: 'Подтверждение email',
  '/': 'Главная',
};

export const APP_TITLE = 'Q-SPA';

export function resolvePageTitle(path: string): string | null {
  const normalized = path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
  const title = PATH_TITLES[path] ?? PATH_TITLES[normalized] ?? null;
  if (title) return title;

  const errorMatch = path.match(/^\/error\/(\d+)$/);
  if (errorMatch) {
    const code = Number(errorMatch[1]);
    return ERROR_CODE_TITLES[code] ?? null;
  }

  return null;
}

export function buildDocumentTitle(pageTitle: string | null): string {
  return pageTitle ? `${APP_TITLE} | ${pageTitle}` : APP_TITLE;
}
